import ImageTexte from './ImageTexte';
import DoubleAuthentification from './DoubleAuthentification';

/**
 * The pop-up modals: one file per modal in this folder, each with its own design.
 * The database row picks one with contenu.modele (« Modèle » in /admin-popups).
 *   image                   : photo, titre et description (every pop-up made from /admin-popups)
 *   double_authentification : the former 2FA modal, its content is fixed
 *
 * To add a modal: create MonModal.jsx here (same props as ImageTexte.jsx) and add it below.
 * Props received by every modal:
 *   popup     : the row (image, cta_url, peut_masquer…)
 *   text      : texts in the page language (titre, texte, cta, plus_tard, rtl…)
 *   open, loading, zIndex
 *   onDone    : main button          onLater : second button          onClose : × / Échap
 *   never, setNever : « Ne plus afficher » checkbox (NeverBox.jsx)
 */
export const MODELES = {
  image: { label: 'Photo, titre et description', component: ImageTexte },
  double_authentification: { label: 'Double authentification (contenu fixe)', component: DoubleAuthentification, fixe: true },
};

// Rows without a model, or with an older name
const PAR_CODE = { otp_2fa: 'double_authentification' };
const ANCIENS = { securite: 'double_authentification', standard: 'image', site_commande: 'image' };

// « standard » was the default of the first version: it never hides the modal of a known code
export const modeleOf = (popup) => {
  const raw = popup && popup.contenu && popup.contenu.modele;
  const name = ANCIENS[raw] || raw;
  if (raw && raw !== 'standard' && MODELES[name]) return name;
  return (popup && PAR_CODE[popup.code]) || 'image';
};

// Every « photo, titre et description » pop-up works like « site de commande »: the main button is
// « Je souhaite être contacté » (email to the team, confirmation in the modal), with « Plus tard » and
// « Ne plus afficher ». Applied to what the API sends and to the /admin-popups preview.
export const commeSiteCommande = (popup) =>
  popup && modeleOf(popup) === 'image' ? { ...popup, cta_action: 'contact', cta_url: null, peut_masquer: true } : popup;
